var _g, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCallback(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 98,
    viewBox: "0 0 111 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter0_f_8040_11126)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 33.3984C32 25.6664 38.268 19.3984 46 19.3984H64.5336C72.2656 19.3984 78.5336 25.6665 78.5336 33.3984V51.9695C78.5336 59.7014 72.2656 65.9695 64.5336 65.9695H46C38.268 65.9695 32 59.7014 32 51.9695V33.3984Z",
    fill: "url(#paint0_linear_8040_11126)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dd_8040_11126)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 33.3984C32 25.6664 38.268 19.3984 46 19.3984H64.5336C72.2656 19.3984 78.5336 25.6665 78.5336 33.3984V51.9695C78.5336 59.7014 72.2656 65.9695 64.5336 65.9695H46C38.268 65.9695 32 59.7014 32 51.9695V33.3984Z",
    fill: "url(#paint1_linear_8040_11126)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8040_11126)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.8458 46.9045V49.9045C65.847 50.183 65.7867 50.4586 65.6687 50.7138C65.5507 50.969 65.3776 51.1981 65.1606 51.3863C64.9435 51.5746 64.6873 51.718 64.4083 51.8072C64.1293 51.8964 63.8336 51.9295 63.5403 51.9045C60.2859 51.5701 57.1599 50.5186 54.4133 48.8345C51.8581 47.2991 49.6916 45.2506 48.0679 42.8345C46.2805 40.2257 45.1682 37.2555 44.8211 34.1645C44.7947 33.8879 44.8294 33.6092 44.9231 33.3461C45.0169 33.083 45.1675 32.8412 45.3655 32.6361C45.5635 32.431 45.8044 32.2672 46.073 32.155C46.3417 32.0428 46.632 31.9847 46.9257 31.9845H50.0984C50.6117 31.9797 51.1092 32.1516 51.4984 32.468C51.8876 32.7845 52.1417 33.2239 52.2136 33.7045C52.3475 34.6645 52.5958 35.6072 52.9539 36.5145C53.0962 36.8724 53.127 37.2614 53.0426 37.6354C52.9583 38.0093 52.7623 38.3526 52.478 38.6245L51.1348 39.8945C52.6404 42.398 54.8326 44.4709 57.4803 45.8945L58.8235 44.6245C59.111 44.3556 59.474 44.1703 59.8695 44.0906C60.265 44.0108 60.6764 44.0399 61.055 44.1745C62.0145 44.513 63.0114 44.7478 64.0268 44.8745C64.5405 44.943 65.0097 45.1877 65.3451 45.562C65.6805 45.9363 65.8587 46.414 65.8458 46.9045Z",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4375 31.9844C59.5931 32.1991 61.6067 33.1032 63.1451 34.547C64.6836 35.9907 65.6548 37.8878 65.8982 39.9244",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4375 35.9844C58.4776 36.1783 59.4321 36.6634 60.177 37.3767C60.922 38.09 61.4229 38.9985 61.6149 39.9844",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_dd_8040_11126)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-6-inside-1_8040_11126",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.75 23.7022C66.75 20.1976 69.591 17.3516 73.0955 17.3516C76.6 17.3516 79.441 20.1976 79.441 23.7022C79.441 27.2067 76.6 30.0527 73.0955 30.0527C69.591 30.0527 66.75 27.2067 66.75 23.7022Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M66.75 23.7022C66.75 20.1976 69.591 17.3516 73.0955 17.3516C76.6 17.3516 79.441 20.1976 79.441 23.7022C79.441 27.2067 76.6 30.0527 73.0955 30.0527C69.591 30.0527 66.75 27.2067 66.75 23.7022Z",
    fill: "url(#paint2_linear_8040_11126)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.75 23.7022M79.441 23.7022M79.441 23.7022M66.75 23.7022M73.0955 17.3516M79.441 23.7022M73.0955 30.0527M66.75 23.7022M73.0955 30.0527V28.0527C70.6976 28.0527 68.75 26.1042 68.75 23.7022H66.75H64.75C64.75 28.3091 68.4843 32.0527 73.0955 32.0527V30.0527ZM79.441 23.7022H77.441C77.441 26.1042 75.4933 28.0527 73.0955 28.0527V30.0527V32.0527C77.7067 32.0527 81.441 28.3091 81.441 23.7022H79.441ZM73.0955 17.3516V19.3516C75.4933 19.3516 77.441 21.3001 77.441 23.7022H79.441H81.441C81.441 19.0952 77.7067 15.3516 73.0955 15.3516V17.3516ZM73.0955 17.3516V15.3516C68.4843 15.3516 64.75 19.0952 64.75 23.7022H66.75H68.75C68.75 21.3001 70.6976 19.3516 73.0955 19.3516V17.3516Z",
    fill: "white",
    mask: "url(#path-6-inside-1_8040_11126)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_8040_11126",
    x: 0,
    y: -12.6016,
    width: 110.531,
    height: 110.57,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16,
    result: "effect1_foregroundBlur_8040_11126"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd_8040_11126",
    x: 20,
    y: 17.3984,
    width: 70.5312,
    height: 70.5703,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_8040_11126"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8040_11126"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_8040_11126"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_8040_11126",
    result: "effect2_dropShadow_8040_11126"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_8040_11126",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_dd_8040_11126",
    x: 54.75,
    y: 15.3516,
    width: 36.6875,
    height: 36.7031,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_8040_11126"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8040_11126"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_8040_11126"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_8040_11126",
    result: "effect2_dropShadow_8040_11126"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_8040_11126",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8040_11126",
    x1: 32,
    y1: 19.3984,
    x2: 78.571,
    y2: 65.932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE9A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F54900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8040_11126",
    x1: 32,
    y1: 19.3984,
    x2: 78.571,
    y2: 65.932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE9A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F54900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8040_11126",
    x1: 66.75,
    y1: 17.3516,
    x2: 79.4512,
    y2: 30.0425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE9A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F54900"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8040_11126"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.382,
    height: 24,
    fill: "white",
    transform: "translate(42.5781 29.9844)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallback);
export default __webpack_public_path__ + "static/media/Call back.2133cb30e23823555a86bb8b032449db.svg";
export { ForwardRef as ReactComponent };